export default __webpack_public_path__ + "70e2e936e3a5108401213f144afd2812.svg";